import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useTableItemsSelection = (selector, setStoreAction) => {
    const dispatch = useDispatch();
    const selectedItems = useSelector(selector);

    const handleSelectItem = useCallback((id) => {
        let newSelectedState = [ ...selectedItems ];

        if (newSelectedState.some((item) => item === id)) {
            newSelectedState = newSelectedState.filter((item) => item !== id);
        } else {
            newSelectedState.push(id);
        }

        dispatch(setStoreAction(newSelectedState));
    }, [ dispatch, selectedItems, setStoreAction ]);

    const handleSelectAll = useCallback((ids) => {
        if(ids.length === selectedItems.length){
            dispatch(setStoreAction([]));
        }else{
            dispatch(setStoreAction(ids));
        }
    }, [ dispatch, selectedItems, setStoreAction ]);

    const isItemSelected = useCallback((id) => (
        selectedItems && selectedItems.some((item) => item === id)
    ), [ selectedItems ]);

    const isSelectedAll = useCallback((ids) => (
        !!(selectedItems &&  selectedItems.length && (ids.length === selectedItems.length))
    ), [ selectedItems ]);

    return {
        selectedItems,
        handleSelectItem,
        handleSelectAll,
        isItemSelected,
        isSelectedAll
    };
};
